import { Logger } from '@hawtiosrc/core/logging'

export const pluginId = 'springboot'
export const pluginName = 'hawtio-springboot'
export const pluginPath = '/springboot'
export const log = Logger.get(pluginName)
